import { Injectable } from "@angular/core";
import { AbstractClass, TableCell } from "@classes/abstract.class";
import { Tenant } from "@models/tenant";

@Injectable({providedIn: 'root'})
export class TenantClass extends AbstractClass {
  model: Tenant;
  modelName = 'Tenant';
  idName = 'tenantID';
  langBase = 'cms.components.tenant.';
  route = '';
  tableCells: TableCell[] = [
    { name: 'tenantID', label: 'id', cellType: 'text', order: true, download: true },
    { name: 'tenantName', label: 'name', cellType: 'text', order: true, download: true },
    { name: 'isActive', label: 'status', cellType: 'active-text', order: true, download: true },
    { name: 'createdAt', label: 'createdAt', cellType: 'date', order: true, download: true },
    //{ name: 'siteLocation.city.countryZone.zoneName', label: 'countryZone', cellType: 'text', order: true },
    //{ name: 'siteLocation.city.cityName', label: 'city', cellType: 'text', order: true },
  ];
  formAccordion = [];
  formTabs = [];
  formCells = [
    // { name: 'name', label: 'name', cellType: 'text', disable: false, order: 1, cols: 'col-12 col-md-6', required: true, multiple: false },
    { name: 'tenantName', label: 'name', cellType: 'text', disable: false, order: 1, cols: 'col-12 col-md-6', required: true, multiple: false, type: 'string' },
    { name: 'isActive', label: 'isActive', cellType: 'checkbox', disable: false, order: 6, cols: 'col-12 col-md-6', required: false, multiple: false, type: 'boolean' }
  ];
  modelCells = [];
  tabs = [];

  constructor()
  {
    super();
    this.model = {
      tenantID: 0,
      tenantName: '',
      isActive: true,
      createdBy: '',
      createdAt: new Date(),
      updatedAt: new Date()
    };
  }
}
